import { useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { SubmitButton } from '../../../../lib/Button';
import TextInput from '../../../../lib/TextField';
import { GENERAL, panRegex } from '../../../../utils/constants';
import { connect } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
const {
    dashboard,
    common,
    signUp: { form },
} = en;

interface TransmissionProps extends RouteComponentProps {
    pan: string;
    pekrn: string;
}

type InputTextState = {
    message?: string;
    value: string;
};

function TransmissionPan(props: TransmissionProps) {
    const isPan = !!props.pan;

    const [holderValue, setHolderValue] = useState<InputTextState>({ value: '' });

    const _handleChange = (e: any) => {
        const { value = '' } = e?.target;
        setHolderValue({ value: value.toUpperCase() });
    };

    const validatePekrn = (value: string) => {
        return value.length >= 9 && value.length <= 12;
    };

    const _onValidate = () => {
        const { value } = holderValue;
        if (isPan) {
            if (!panRegex.test(value)) {
                return setHolderValue({ value, message: form.pan.validations.regexError });
            }
        }
        if (value.length == 0) {
            return setHolderValue({ value, message: form.pekrn.validations.emptyError });
        }
        if (value.length < 9 || value.length > 12) {
            return setHolderValue({ value, message: form.pekrn.validations.regexError });
        }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.TransmissionRequest.TransmissionRequestHeading} />
            <div className="curved-bg-content">
                <img className="change-email-img" src="/images/change-email-img.png" alt="icon" />
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top">
                        <h3 className="subheading">
                            {dashboard.TransmissionRequest.postLogin.subHeading}
                            <span>
                                {isPan
                                    ? dashboard.TransmissionRequest.postLogin.subHeadingSpanPan
                                    : dashboard.TransmissionRequest.postLogin.subHeadginSpanPekrn}
                            </span>
                        </h3>
                        <p>
                            {isPan
                                ? dashboard.TransmissionRequest.postLogin.subHeadingInfoPan
                                : dashboard.TransmissionRequest.postLogin.subHeadingInfoPekrn}
                        </p>
                        <TextInput
                            helperText={holderValue.message}
                            error={!!holderValue.message}
                            onBlur={_onValidate}
                            onChange={_handleChange}
                            value={holderValue.value}
                            variant="outlined"
                            label="Enter Here"
                            name="email"
                        />
                    </div>
                    <FaqLink section={GENERAL} history={props.history} />
                    <div className="curved-bg-content-inner-bottom">
                        <SubmitButton
                            label={dashboard.TransmissionRequest.postLogin.proceedBtn}
                            className="customBtn"
                            onClick={() =>
                                props.history.push('/portal/nct/transmission-list', {
                                    deceasedPersonPAN: holderValue.value,
                                })
                            }
                            disabled={
                                isPan
                                    ? !panRegex.test(holderValue.value)
                                    : !validatePekrn(holderValue.value)
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }))(TransmissionPan);
